import React from 'react';
import {useFormikContext} from 'formik';
import {useParams} from 'react-router-dom';
import Modal from 'shared/components/modal';

interface Props {
  onDelete?: () => void;
}

const ModalFooter = ({onDelete}: Props) => {
  const formik = useFormikContext();
  const {id} = useParams<{id: string}>();

  return (
    <Modal.Footer
      primaryButton={{
        type: 'submit',
        width: 120,
        disabled: formik.isSubmitting || !formik.isValid,
        text: formik.isSubmitting ? 'Saving...' : 'Save',
      }}
      tertiaryButton={
        id !== 'new' && onDelete ? {text: 'Delete', color: 'red', onClick: onDelete} : undefined
      }
    />
  );
};

export default ModalFooter;
